import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'

export default {
  revenue: [
    {
      name: 'total_revenue',
      key: 'totalRevenue',
      link: 'total-revenue'
    },
    {
      name: 'revenue_by_payment_date',
      key: 'total-revenue-payment-date',
      link: 'total-revenue-payment-date'
    },
    {
      name: 'net_revenue',
      key: 'netRevenue',
      link: 'net-revenue'
    },
    {
      name: 'revenue_by_customer',
      key: 'revenueByCustomer',
      link: 'revenue-by-customer'
    },
    {
      name: 'revenue_by_outlet',
      key: 'revenueByOutlet',
      link: 'revenue-by-outlet'
    },
    {
      name: 'revenue_by_seller',
      key: 'seller',
      link: 'seller'
    },
    {
      name: 'revenue_by_cashier',
      key: 'cashier',
      link: 'cashier'
    },
    {
      name: 'revenue_by_category',
      key: 'revenueByCategory',
      link: 'revenue-by-category'
    },
    {
      name: 'sale_report',
      key: 'salesReport',
      link: 'sales-report'
    },
    {
      name: 'payment_methods',
      key: 'payment',
      link: 'payment'
    }
  ],
  orders: [
    {
      name: 'total_number_of_orders',
      key: 'numberOfOrders',
      link: 'number-of-orders'
    },
    {
      name: 'order_count_by_payment_date',
      key: 'number-of-orders-payment-date',
      link: 'number-of-orders-payment-date'
    },
    {
      name: 'average_order_value',
      key: 'averageOrderValue',
      link: 'average-order-value'
    },
    {
      name: 'order_value_by_payment_date',
      key: 'average-order-value-payment-date',
      link: 'average-order-value-payment-date'
    },
    {
      name: 'average_item_per_order',
      key: 'averageItemPerOrder',
      link: 'average-item-per-order'
    },
    {
      name: 'sales_order',
      key: 'salesOrder',
      link: 'sales-order'
    },
    {
      name: 'refund',
      key: 'refund',
      link: 'refund'
    },
    {
      name: 'discount',
      key: 'discount',
      link: 'discount'
    },
    {
      name: 'fulfillment',
      key: 'fulfillment',
      link: 'fulfillment'
    },
    {
      name: 'payment_status',
      key: 'paymentStatus',
      link: 'payment-status'
    },
    ...(getItemByLocalStorage(localStorageKey.CURRENT_PLATFORM) === 'msi'
      ? [
        {
          name: 'order_status',
          key: 'orderStatus',
          link: 'order-status'
        }
      ]
      : []),
    {
      name: 'average_duration',
      key: 'averageDuration',
      link: 'average-duration'
    },
    {
      name: 'time_in_status',
      key: 'timeInStatus',
      link: 'time-in-status'
    },
    {
      name: 'tippings',
      key: 'tippings',
      link: 'tippings'
    }
  ],
  products: [
    {
      name: 'quantity_sold',
      key: 'productSold',
      link: 'product-sold'
    },
    {
      name: 'revenue_by_product',
      key: 'revenueByProduct',
      link: 'revenue-by-product'
    }
  ],
  globalOptions: [
    {
      name: 'outlets',
      key: 'global',
      link: 'global'
    },
    {
      name: 'countries',
      key: 'global-stores',
      link: 'global-stores'
    }
  ],
  tax: [
    {
      name: 'tax',
      key: 'tax',
      link: 'tax'
    },
    {
      name: 'monthly_report',
      key: 'monthlyReport',
      link: 'monthly-report'
    },
    {
      name: 'daily_report',
      key: 'dailyReport',
      link: 'daily-report'
    }
  ]
}
